import styled from 'styled-components'

export const RowStyle = styled.div`
  @media (max-width: 600px) {
    display: grid;
    position: abslute;
    // span:first-of-type {
    //   grid-column: 1 / span 2;
    // }
    span:nth-last-child(2) {
      grid-column: 1 / span 2;
    }
    span:last-of-type {
      grid-column: 1 / span 2;
    }
    border: 1px solid;
    border-color: lightgrey;
    border-radius: 0px;
    width: 80%;
    margin: auto;
  }
  border: 2px solid;
  border-color: black;
  border-radius: 15px;
  display: flex;
  flex-direction: row;
  //width: 98%;
  justify-content: center;
`
